import { lazy, Suspense, forwardRef } from "react";
import type { ComponentProps } from "react";
import type { SQLEditorRef } from "./SQLCodeEditor";
import type { CodeEditorHandle } from "./CodeEditor";
import type { CodeDiffEditorHandle } from "./CodeDiffEditor";

export type { SQLEditorRef };

const LazyCueCodeEditor = lazy(() => import("./CueCodeEditor"));
const LazySQLCodeEditor = lazy(() => import("./SQLCodeEditor"));
const LazyCodeEditor = lazy(() => import("./CodeEditor"));
const LazyROCodeEditor = lazy(() => import("./ROCodeEditor"));
const LazyCodeDiffEditor = lazy(() => import("./CodeDiffEditor"));
const LazyCodeDiff2Editor = lazy(() => import("./CodeDiff2Editor"));

export const CueCodeEditor = (props: ComponentProps<typeof LazyCueCodeEditor>) => (
  <Suspense fallback={<div>Loading...</div>}>
    <LazyCueCodeEditor {...props} />
  </Suspense>
);
export const CodeSQLEditor = forwardRef<SQLEditorRef, ComponentProps<typeof LazySQLCodeEditor>>(
  function Editor(props, ref) {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <LazySQLCodeEditor {...props} ref={ref} />
      </Suspense>
    );
  }
);

export const ROCodeEditor = (props: ComponentProps<typeof LazyROCodeEditor>) => (
  <Suspense fallback={<div>Loading...</div>}>
    <LazyROCodeEditor {...props} />
  </Suspense>
);

export const CodeEditor = forwardRef<CodeEditorHandle, ComponentProps<typeof LazyCodeEditor>>(
  function Editor(props, ref) {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <LazyCodeEditor {...props} ref={ref} />
      </Suspense>
    );
  }
);

export const CodeDiffEditor = forwardRef<
  CodeDiffEditorHandle,
  ComponentProps<typeof LazyCodeDiffEditor>
>(function Editor(props, ref) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LazyCodeDiffEditor {...props} ref={ref} />
    </Suspense>
  );
});

export const CodeDiff2Editor = forwardRef(function Editor(
  props: ComponentProps<typeof LazyCodeDiff2Editor>,
  ref
) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LazyCodeDiff2Editor {...props} ref={ref} />
    </Suspense>
  );
});
